import { DataPage } from '@/app.routes';
import { NavService } from '@/services/nav.service';
import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({ template: '' })
export abstract class BasePageComponent implements OnDestroy {
  dataSub = new Subscription();

  constructor(protected route: ActivatedRoute, protected navService: NavService) {
    this.initPage();
  }

  ngOnDestroy(): void {
    this.dataSub.unsubscribe();
  }

  initPage(): void {
    this.dataSub = this.route.data.subscribe((paramMap: Data) => {
      const dataPage: DataPage = {
        level: paramMap.level,
        page: paramMap.page,
        uid: this.navService.currentDataPage$.getValue()?.uid || null
      };
      this.navService.currentDataPage$.next(dataPage);
    });
  }
}
